import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import UKToast from '@/components/UKToast'
import { useTranslation } from '@/i18n/client';

interface Props {
  text: string;
  children: React.ReactNode;
}

const UKCopy: React.FC<Props> = ({ text, children }) => {
  const { t } = useTranslation();

  const copyHandler = () => {
    UKToast.show({
      content: t('common.message.copySuccessful'),
      icon: 'success',
      duration: 2000,
    });
  };

  return (
    <CopyToClipboard text={text} onCopy={copyHandler}>
      {children}
    </CopyToClipboard>
  );
};

export default UKCopy;
